export enum AssessmentSidebarTab {
  artifacts = "Items",
  workHistory = "Work history",
  askAI = "Topicflow AI",
  roles = "Roles",
  reviews = "Reviews",
}
